// extracted by mini-css-extract-plugin
module.exports = {"w1b00398":"w1b00398"};